(() => {
  const observers = new WeakMap();

  const initializeTechnicalSpecs = (root = document) => {
    const sections = root.matches?.('[data-k9-technical-specs]')
      ? [root]
      : [...root.querySelectorAll('[data-k9-technical-specs]')];
    const header = document.getElementById('shopify-section-header');
    if (!header) return;

    sections.forEach((section) => {
      if (observers.has(section)) return;

      const updateHeaderHeight = () => {
        section.style.setProperty('--k9-specs-header-height', `${header.getBoundingClientRect().height}px`);
      };

      updateHeaderHeight();

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(updateHeaderHeight);
        observer.observe(header);
        observers.set(section, { observer });
      } else {
        window.addEventListener('resize', updateHeaderHeight);
        observers.set(section, { updateHeaderHeight });
      }
    });
  };

  const disconnectTechnicalSpecs = (root) => {
    const sections = root.matches?.('[data-k9-technical-specs]')
      ? [root]
      : [...root.querySelectorAll('[data-k9-technical-specs]')];

    sections.forEach((section) => {
      const entry = observers.get(section);
      if (!entry) return;
      entry.observer?.disconnect();
      if (entry.updateHeaderHeight) window.removeEventListener('resize', entry.updateHeaderHeight);
      observers.delete(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeTechnicalSpecs(), { once: true });
  } else {
    initializeTechnicalSpecs();
  }

  document.addEventListener('shopify:section:load', (event) => initializeTechnicalSpecs(event.target));
  document.addEventListener('shopify:section:unload', (event) => disconnectTechnicalSpecs(event.target));
})();
